/**
 * this holds the constants for the AppsApi
 * used by the API and by the Apps component of SiteBuilder
 * @author marian.cojoc@1and1.ro
 */
export = {
    errors: {
        WEB_COMPONENT_ID_NOT_FOUND: 'web_component_not_found',
        WEB_COMPONENT_ID_NOT_INSTALLED: 'web_component_not_installed',
        WEB_COMPONENT_ID_NOT_IN_CATEGORY: 'requested_web_component_not_in_category',

        WEB_COMPONENT_ALREADY_INSTALLED: 'web_component_already_instaled', //for install
        WEB_COMPONENT_NOT_INSTALLABLE: 'web_component_not_installable', //for install

        MODULE_MAIN_CATEGORY_NOT_FOUND: 'main category module not found for web component',
        MODULE_SELECTOR_OPENING_EVENT: 'could not open module selector for web component',
        BAD_REQUEST: 'bad_request',

        //could not connect to server, or the server did not respond properly
        INTERNAL_SERVER_ERROR: 505
    },

    pageCreationSteps: {
        STEP_PREPARATION: 'step_preparation',
        STEP_PAGE_CREATION: 'page_creation',
        STEP_WEBCOMPONENT_CREATION: 'webcomponent_creation'
    },

    //used to request all web components statuses
    ALL_WEB_COMPONENTS: 'allWebComponents',

    INSTALLED_STATUS_INSTALLED: 'status_installed',
    INSTALLED_STATUS_NOT_INSTALLED: 'status_not_installed',
    INSTALLED_STATUS_NOT_INSTALLABLE: 'status_not_installable',
    INSTALLED_STATUS_NOT_FOUND: 'status_not_found',
    INSTALLED_STATUS_ERROR: 'status_error',

    REQUEST_FEATURE_IS_AVAILABLE: 'featureIsAvailable',
    REQUEST_STATUS: 'getStatus',
    REQUEST_FOCUS: 'doFocus',
    REQUEST_INSTALL: 'doInstall'
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/external/appsApiConstants.ts
 **/